import { actionCreatorFactory } from 'typescript-fsa';

/**
 * Action Creators
 */
export const actionCreator = actionCreatorFactory(
  `@@LENDSMARTMANAGER/ADVISOR_PROFILE`
);

export const advisorProfileRequest = actionCreator('request');

export const advisorProfileRequestSuccess = actionCreator<any>('success');

export const advisorProfileRequestFail = actionCreator<string>('fail');

export const setAdvisorProfile = actionCreator('update');
export const setAdvisorProfileSuccess = actionCreator('update-success');
export const setAdvisorProfileFail = actionCreator('update-fail');
